<template>
  <div>
    <v-dialog :value="dialog" persistent max-width="700px" overlay-opacity=".9">
      <v-card>
        <v-toolbar color="primary" class="white--text">
          <v-toolbar-title>
            <v-icon class="white--text" left size="20">mdi-image</v-icon>
            {{cardTitle}}
          </v-toolbar-title>

          <v-spacer />
          <v-btn icon dark @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <empty-state :when="items.length == 0" :message="$capitalize($tc('model.gallery_no_images'))" height="400">
          <v-card flat>
            <v-container fluid>
              <v-card-title>
                {{ $capitalize($tc("model.gallery_images")) }}
                <v-spacer />
                <v-btn class="mx-1" @click="submit" color="primary">
                  <v-icon size="24" left>mdi-plus</v-icon>{{ $capitalize($tc("model.gallery_add"))}}
                </v-btn>
              </v-card-title>
              <v-item-group
                v-model="selectedAttachments"
                multiple
              >
                <v-virtual-scroll
                  :bench="1"
                  :items="chunked_attachments"
                  :item-height="lineHeight"
                  height="400"
                >
                  <template v-slot="{ item }">
                    <v-row dense no-gutters>
                      <v-col
                        v-for="attachment in item"
                        :key="attachment.id"
                        class="d-flex child-flex px-1"
                        :cols="numCols"
                      >
                        <v-item v-slot:default="{ active, toggle }">
                          <v-card
                            tile
                            class="mx-auto"
                            @click="toggle"
                          >
                            <v-img
                              :src="attachment.public_url"
                              aspect-ratio="1"
                              class="grey lighten-2"
                              :height="imageHeight"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                              </template>
                              <v-overlay
                                v-if="active"
                                absolute
                                color="primary"
                              />
                            </v-img>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </template>
                </v-virtual-scroll>
              </v-item-group>
            </v-container>
          </v-card>
        </empty-state>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EmptyState from './EmptyState';
export default {
  name: "select-images-dialog",
  components: {
    EmptyState
  },
  model: {
    prop: "dialog",
    event: "change"
  },
  props: {
    dialog: Boolean,
    items: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    selectedAttachments: []
  }),
  methods: {
    handleClose() {
      this.$emit('change', false);
    },
    async submit() {
      const selected = [];

      this.items.forEach((item, index) => {
        if (this.selectedAttachments.includes(index))
          selected.push(item);
      });
      
      this.$listeners.submit(selected);
    }
  },
  computed: {
    cardTitle: function() {
      if (this.selectedAttachments.length == 0)
        return 'Selecione as imagens';
      
      if (this.selectedAttachments.length == 1)
        return '1 imagem selecionada';

      return `${this.selectedAttachments.length} imagens selecionadas`;       
    },
    lineHeight: function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '110';
        case 'sm': return '130';
        case 'md': return '130';
        case 'lg': return '130';
        case 'xl': return '110';
      }

      return '110';
    },
    imageHeight: function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100';
        case 'sm': return '120';
        case 'md': return '120';
        case 'lg': return '120';
        case 'xl': return '100';
      }

      return '100';
    },
    numCols: function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 6;
        case 'sm': return 4;
        case 'md': return 3;
        case 'lg': return 3;
        case 'xl': return 2;
      }

      return 6;
    },
    itemsPerLine: function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 2;
        case 'sm': return 3;
        case 'md': return 4;
        case 'lg': return 4;
        case 'xl': return 6;
      }

      return 6;
    },
    chunked_attachments: function() {
      const groupsOfAttachments = [];
      for(let i = 0; i < this.items.length; i += this.itemsPerLine) {
        groupsOfAttachments.push(this.items.slice(i, i + this.itemsPerLine));
      }

      return groupsOfAttachments;
    }
  }
};
</script>